import AuthHttpService from "./AuthHttpService";

import {
  ICreatorsItemsList,
  IHistoryList,
  INichesItems,
  ITagsList,
  ITrendingTagsList,
} from "./types";

export default class SearchService extends AuthHttpService {
  public constructor(readonly url?: string) {
    super(url);
  }

  async getTrendingSearches(): Promise<ITrendingTagsList> {
    return await this.get("v2/search/trending");
  }

  async getCreatorsSearches(query: string): Promise<ICreatorsItemsList> {
    return await this.get(`v2/creators/search?query=${query}`);
  }

  async getNichesSearches(query: string): Promise<INichesItems[]> {
    return await this.get(`v2/niches/search?query=${query}`);
  }

  async getTagsSearches(query: string): Promise<ITagsList[]> {
    return await this.get(`v2/search/suggest?query=${query}`);
  }

  async getHistorySearches(query: string): Promise<IHistoryList> {
    return await this.get(`v2/search/history?query=${query}`);
  }
}
